module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<tr>\n  <td>")
    ; __append(escapeFn( user.username ))
    ; __append("</td>\n  <td><input type=\"text\" class=\"distanceTextField\" id=\"distance-")
    ; __append(escapeFn( user.id ))
    ; __append("\" value=\"")
    ; __append(escapeFn( user.user_information.testing_distance))
    ; __append("\"></td>\n  <td>")
    ; __append(escapeFn( user.user_information.testing_speed))
    ; __append("</td>\n  <td><input type=\"button\" value=\"Remove\" class=\"btn btn-warning testerRemover\" data-user-id=\"")
    ; __append(escapeFn( user.id ))
    ; __append("\"></td>\n</tr>")
  }
  return __output;

}